import React, { useContext, useEffect } from "react";
import './navbar.style.scss';
import { AccountContext } from "../../../Contexts/main.context";
import { setButtons } from "../../../Functions/theFunctions";


const NavBar = () => {

     async function loadButtons(locationName, locationCount, citationCount) {
          const buttons = await setButtons(locationName, locationCount, citationCount);
          updateActionButtons(buttons); // or whatever you're doing with the buttons
     }



     const { clientAccounts, updateActionButtons, updateActiveClient, masked, updateOriginalID, originalID, updateActiveOutlet, activeOutlet, returnToLastLink  } = useContext(AccountContext);

     useEffect(() => {
          if (returnToLastLink === 'Clients') {
               updateActiveOutlet('Clients');
               return;
          }
          const selectedClient = clientAccounts.find(client => String(client.ID) === String(originalID));

          if (!selectedClient) {
               console.warn("Client not found");
               return;
          }

          const extraLocations = clientAccounts.filter(client => String(client.locationID) === String(originalID));
          const locationCount = extraLocations.length;
          selectedClient.LocationCount = locationCount;

          const citationCount = selectedClient.citationCount;

          updateActiveClient(selectedClient);
          updateOriginalID(selectedClient.ID);
          updateActiveOutlet('ViewLocation');
          loadButtons('ClientData', locationCount, citationCount);
     }, [clientAccounts, originalID]);




     const clientChanged = (id) => {
          switch (id) {

               default:
                    const selectedClient = clientAccounts.find(client => String(client.ID) === String(id));
                    if (!selectedClient) {
                         return;
                    }
                    const extraLocations = clientAccounts.filter(client => String(client.locationID) === String(id));
                    const locationCount = extraLocations.length;
                    if (selectedClient) {
                         selectedClient.LocationCount = locationCount;
                    }
                    const citationCount = selectedClient.citationCount;

                    updateActiveClient(selectedClient);
                    updateOriginalID(selectedClient.ID);
                    updateActiveOutlet('ViewLocation');

                    if (!selectedClient) {
                         console.warn("Client not found");
                         return;
                    }

                    loadButtons('ClientData', locationCount, citationCount);

                    break;

          }

     };


     return (
          <div className="navbar-wrapper">
               <div className="ms-auto d-flex flex-grow-1 gap-2 col-24 justify-content-end">
                    {activeOutlet && activeOutlet !== 'editCustomer' && (
                         <div className="col-36 col-md-30 col-lg-24 col-xl-18 d-flex align-items-center gap-2">
                              <div className="text-white">Account:</div>
                              <div style={{ flex: 1 }}>
                                   <select
                                        name="client"
                                        className="form-select w-100"
                                        value={originalID} // 🔥 this keeps it in sync
                                        onChange={(e) => clientChanged(e.target.value)}>
                                        <option value="-">Choose Client</option>
                                        {clientAccounts
                                             .filter(client => client.locationID === '0' && client.status === 'Active')
                                             .map((client, index) => (
                                                  <option key={index} value={client.ID}>
                                                       {client.companyName}
                                                  </option>
                                             ))}
                                   </select>

                              </div>
                         </div>
                    )}
               </div>
               {masked && (
                    <div className="navbar-mask-overlay"></div>
               )}
          </div>
     )
}

export default NavBar;
